export default "__VITE_ASSET__HYJM12ww__"